export default "__VITE_ASSET__CEip6QVa__"